@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.phone-number-field {
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  > label {
    font-size: 14px;
    font-weight: @bold;
  }

  > input {
    margin-top: 5px;
    height: 40px;
    max-width: 200px;
    font-size: 16px;
    font-weight: @normal;
  }
}

.error {
  font-size: 12px;
  color: @phone-verify--error--text-color;
  margin-top: 5px;
}
